<template>
    <div>
        <v-list two-line>
            <v-list-item v-for="(messages, thread) in textMessages" :key="thread" :to="'/messaging/' + thread">
                <v-list-item-content>
                    <v-list-item-title>Chat with {{ threadInfo[thread]["title"] || threadInfo[thread]["title1"] || "Unknown Sender" }}</v-list-item-title>
                    <v-list-item-subtitle>{{ messages[messages.length - 1].content || "No messages" }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>

        <v-container v-if="Object.keys(textMessages).length <= 0">
            <v-alert type="info">
                You don't have any messages yet! Use the button in the bottom right of the screen to send one.
            </v-alert>
        </v-container>

        <v-btn color="secondary" fixed bottom right fab @click.stop="dialog = true">
            <v-icon>mdi-pencil</v-icon>
        </v-btn>

        <v-dialog v-model="dialog" max-width="350">
            <SendMessage type="text"/>
        </v-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import SendMessage from '../components/SendMessage.vue';

export default {
    data: () => ({
        dialog: false,
        drawer: false
    }),
    components: {
        SendMessage
    },
    computed: mapState([
        "textMessages",
        "threadInfo",
        "players"
    ]),
    sockets: {
        send_event(state) {
            if (state == "sent") { this.dialog = false; }
        }
    },
    methods: {
        getPlayer(id) {
            return this.players.find(p => p.id == id);
        }
    }
}
</script>
